// Material UI
import { makeStyles } from '@material-ui/core';
// Consts
import { neutral } from '../../shared/styles/colors';

export default makeStyles(theme => ({
  customAlertPaymentMethodRoot: {
    fontSize: '0.75rem',
    fontFamily: 'PP Object Sans',
    fontStretch: 'normal !important',
    fontStyle: 'normal !important',
    lineHeight: 'normal !important',
    letterSpacing: 0,
    textAlign: 'initial !important',
    padding: '10px !important',
    width: '100%',
  },
  description: {
    fontFamily: 'PP Object Sans',
    whiteSpace: 'pre-line',
  },
  root: {
    color: neutral[100],
    display: 'grid',
    gridRowGap: 12,
    fontSize: '0.875rem',
    lineHeight: 'normal',
  },
}));
